import { Resource } from "src/app/core/jsonapi/resource";
import { prop } from "@rxweb/reactive-form-validators";

export class DialPlan extends Resource {
    public override type = 'dialPlans';

    @prop()
    public name!: string;
}
